import { Box } from '@mui/material';
import type { FC } from 'react';

import { PortableText } from '~/components/atoms/PortableText';
import { Accordion } from '~/components/molecules/Accordion';
import type { OmitTypeAndKey } from '~/types';
import type { AccordionProps } from '~/types/sanity/components';
import { isPortableTextBlockArray } from '~/utils/portableTextUtils';

export const AccordionSanity: FC<OmitTypeAndKey<AccordionProps>> = ({ accordionItems }) => {
  const formattedAccordionItems = accordionItems.map(({ _key, accordionTitle, accordionContent }) => ({
    id: _key,
    title: accordionTitle,
    item: isPortableTextBlockArray(accordionContent) && <PortableText portableText={accordionContent} />,
  }));

  return (
    <Box>
      {formattedAccordionItems.map((accordionItem) => (
        <Accordion key={accordionItem.id} {...accordionItem} />
      ))}
    </Box>
  );
};
